export default __webpack_public_path__ + "static/media/shopping-statue (2).2e85da3c.webp";